import React, { useState, useEffect } from "react";
import appURL from '../../appURL.json';
import config from '../../config.json';
import TauriLoader from "../TauriLoader/TauriLoader";
import { TableConfiguration } from "../TauriVisualFactory/TauriVisualChartConfiguration/TauriVisualChartConfiguration";
import TauriCustomPaganation from "../TauriCustomPaganation/TauriCustomPaganation";
import TauriSearchResultDetailModal from "../TauriSearchResultDetailModal/TauriSearchResultDetailModal";
import { AccessComponentFactory } from "../../visualizations/AccessComponentFactory";
import DataTable from "react-data-table-component";
import './TauriListings.css';
import { useParams } from "react-router-dom";

const TauriListings = ({ }) => {
    const [catalogs, setCatalogs] = useState([]);
    const [filteredCatalogs, setFilteredCatalogs] = useState([]);
    const [paginatedCatalogs, setPaginatedCatalogs] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [displayPerPage, setDisplayPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / displayPerPage);

    const { id } = useParams();

    const getPermission = localStorage.getItem('permission');
    const decodedPermission = JSON.parse(atob(getPermission));

    const access = decodedPermission?.DataScope?.Access;
    const colorscheme = AccessComponentFactory('colorScheme', access?.Access ? access?.Access.toString() : '-1');

    const palettes = colorscheme.palettes.find(pal => pal.id === 'palette21').ranges;

    const Catalogs_MAP = [
        { id: "regions", code: "TLRG", path: "/regions" },
        { id: "districts", code: "TLDS", path: "/districts" },
        { id: "dms", code: "TLDM", path: "/districts" },
        { id: "territories", code: "TLTR", path: "/territories" },
        { id: "employees", code: "TLEMP", path: "/agents" },
        { id: "c-groups", code: "TLCG", path: "/c-groups" },
        { id: "p-groups", code: "TLPG", path: "/p-groups" },
        { id: "products", code: "TLPR", path: "/items" }
    ];

    const fetchCatalogs = async () => {
        setLoading(true);
        const token = localStorage.getItem('token');

        const catalogItem = Catalogs_MAP.find(catalog => catalog.id === id);

        const requestBody = {
            "id": catalogItem.code,
            "params": [
                {
                    "key": "EmployeeCode", "value": access.AccessRange
                }
            ]
        };

        try {
            const response = await fetch(appURL.API_GetData, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                console.error('Failed to fetch data:', response.status);
                setCatalogs([]);
                return;
            }

            const data = await response.json();
            const parsedData = JSON.parse(data.result.data);
            setCatalogs(parsedData);
            setTotalItems(parsedData.length);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCatalogs();
    }, [id]);

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedItem(null);
    };

    const columns = [
        {
            name: 'Identifier',
            selector: row => row.Identifier,
            omit: true
        },
        {
            name: 'Code',
            selector: row => row.Code,
            sortable: true,
            grow: 1
        },
        {
            name: 'Name',
            selector: row => row.Name,
            sortable: true,
            grow: 5
        }
    ];

    const customStyle = {
        ...TableConfiguration.customStyle,
        headRow: {
            style: {
                backgroundColor: palettes[0],
                border: `1px solid ${palettes[1]}`,
            }
        },
        rows: {
            style: {
                ...TableConfiguration.customStyle.rows.style,
                border: `1px solid ${palettes[1]}`,
            },
            highlightOnHoverStyle: {
                backgroundColor: palettes[2],
                color: palettes[4],
            }
        },
        footerRow: {
            style: {
                backgroundColor: palettes[0],
                fontWeight: 'bold',
            }
        }
    };

    useEffect(() => {
        const filtered = catalogs.filter(item =>
            item.Code.toLowerCase().includes(search.toLowerCase()) ||
            item.Name.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredCatalogs(filtered);
        setTotalItems(filtered.length);
        setCurrentPage(1);
    }, [search, catalogs]);

    useEffect(() => {
        const start = (currentPage - 1) * displayPerPage;
        const end = start + displayPerPage;
        setPaginatedCatalogs(filteredCatalogs.slice(start, end));
    }, [filteredCatalogs, currentPage, displayPerPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDisplayPerPage = (newDisplayPerPage) => {
        setDisplayPerPage(newDisplayPerPage);
        setCurrentPage(1);
    };

    const handleRowClick = (row) => {
        const catalogItem = Catalogs_MAP.find(catalog => catalog.id === id);

        if (id === "territories" || id === "c-groups") {
            return;
        }

        const item = {
            "access_path": `${catalogItem.path}?id=${row.Identifier}`,
            "header": row.Name,
            "identifier": row.Identifier
        }
        setSelectedItem(item);
        setShowModal(true);
    };

    return (
        <div className="tauri-listings-container">
            <div className="mb-3">
                <div className="form-group d-flex align-items-center">
                    <input
                        type="text"
                        id="searchInput"
                        placeholder="Search..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="form-control"
                        aria-label="Search"
                    />
                </div>
            </div>


            {loading ? (
                <TauriLoader borderSize={'0.2rem'} widthSize={'2.5rem'} heightSize={'2.5rem'} />
            ) : (
                <div>
                    <DataTable
                        className="listings-table"
                        columns={columns}
                        data={paginatedCatalogs}
                        onRowClicked={handleRowClick}
                        customStyles={customStyle}
                        highlightOnHover={TableConfiguration.highlightOnHover}
                        pointerOnHover={TableConfiguration.pointerOnHover}
                        striped={TableConfiguration.striped}
                        fixedHeader={TableConfiguration.fixedHeader}
                        responsive={TableConfiguration.responsive}
                        expandOnRowClicked={TableConfiguration.expandOnRowClicked}
                        expandableRows={TableConfiguration.expandableRows}
                        expandableRowsHideExpander={TableConfiguration.expandableRowsHideExpander}
                        pagination={TableConfiguration.pagination}
                    />
                    <TauriCustomPaganation
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        displayPerPage={displayPerPage}
                        onDisplayPerPage={handleDisplayPerPage}
                        totalItems={totalItems}
                    />
                </div>
            )}

            <TauriSearchResultDetailModal
                show={showModal}
                onHide={handleCloseModal}
                item={selectedItem}
            />
        </div>
    );
};

export default TauriListings;